import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'
import styles from './SecondaryTabsBar.module.scss'
import { SecondaryTab } from './SecondaryTab/SecondaryTab'

export const SecondaryTabsBar = ({
  activeTab,
  className = undefined,
  tabClassName = undefined,
  iconClassName = undefined,
  tabs,
  setActiveTab,
}) => {
  const tabWidth = Math.round(R.divide(100, tabs.length) * 10) / 10
  const indicatorTransition = R.multiply(
    R.findIndex(R.propEq('id', activeTab), tabs),
    tabWidth,
  )

  return (
    <div className={cx(styles.tabs, className)}>
      <div className={styles.tabsContainer}>
        {R.addIndex(R.map)(
          ({ id, label, isDisabled = false, icon = null }, index) => (
            <SecondaryTab
              {...{
                id,
                icon,
                label,
                isDisabled,
                setActiveTab,
                tabClassName,
                iconClassName,
                isActiveTab: R.equals(activeTab, id),
              }}
            />
          ),
          tabs,
        )}
      </div>

      <div
        className={styles.indicator}
        style={{
          [`--width`]: `${tabWidth}%`,
          [`--left`]: `${indicatorTransition}%`,
        }}
      ></div>
    </div>
  )
}
